import { render } from "./ProductSwiper.vue?vue&type=template&id=9634ee56"
import script from "./ProductSwiper.vue?vue&type=script&lang=js"
export * from "./ProductSwiper.vue?vue&type=script&lang=js"

import "./ProductSwiper.vue?vue&type=style&index=0&id=9634ee56&lang=css"
script.render = render

export default script